<template>
    <span>
        <span v-if="showMore">
            {{words.slice(0, len).join(' ')}}
        </span>
        <span v-else>
            {{text}}
        </span>
        <a-space v-if="showIcon">
            <a @click="handleChange" style="margin-left: 5px">
                <DownCircleOutlined v-if="showMore"/>
                <UpCircleOutlined v-else/>
            </a>
        </a-space>

    </span>
</template>

<script>
    import {DownCircleOutlined, UpCircleOutlined} from '@ant-design/icons-vue';
    import {setState} from "../utils/vue.tool";

    export default {
        name: "MoreORLess",
        components: {
            DownCircleOutlined, UpCircleOutlined
        },
        props: ['len', 'noTip', 'text'],
        data(){
            let {text, len} = this;
            text = text || '';
            let words = text.split(' ');
            return {
                words,
                showIcon: words.length > len,
                showMore: true,
                tipText: 'Show more',
            }
        },
        methods: {
            setState(values){
                setState(this, values);
            },
            handleChange(){
                let {showMore} = this;
                this.setState({
                    showMore: !showMore,
                    tipText: showMore? ('Show more'): ('Show less'),
                })
            }
        }
    }
</script>

<style scoped>

</style>